import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ConcretePLIconProps {
  size?: number;
  color?: string;
}

const ConcretePLIcon: React.FC<ConcretePLIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-concretepl">
    {
      <path d="M21.043 15.101v-6.156c0-0.044-18.086-0.061-18.086-0.061v6.208c0 0.044 18.070 0.014 18.086 0.009z"></path>

    }  </SvgIcon>
);

export default ConcretePLIcon;
